import { Center } from "styled-system/jsx";
import { Tree } from "iconoir-react/regular";
import { Button, Heading, Icon, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Trans } from "react-i18next";
import { handleBeaconClick } from "shared/utils";
import { useAuth0 } from "@auth0/auth0-react";
import { Refresh } from "iconoir-react";

export const ErrorBoundaryPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth0();

  return (
    <Center bg={"bg.wa.lightest"} w={"full"} h={"full"} p={"1000"}>
      <Center maxW={"600px"} gap={"400"} flexDir={"column"}>
        <Icon Element={Tree} w={"60px"} h={"60px"} color={"icon.success.mid"} />
        <Heading size={"h4"}>{t("core:ERROR_BOUNDARY.TITLE")}</Heading>
        <Trans
          i18nKey={"core:ERROR_BOUNDARY.DESCRIPTION"}
          components={{
            Text: (
              <Text
                visual={"bodyMedium"}
                color={"text.mid"}
                textAlign={"center"}
              />
            ),
            Button: (
              <Button
                visual="unstyled"
                textDecoration={"underline"}
                display="inline"
                onClick={() => handleBeaconClick(user)}
              />
            ),
          }}
        />
        <Button
          visual={"primary"}
          mode={"light"}
          size={"lg"}
          Icon={Refresh}
          onClick={() => navigate(0)}
        >
          {t("core:ERROR_BOUNDARY.CTA_BUTTON_COPY")}
        </Button>
      </Center>
    </Center>
  );
};
